import { Column, Button } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { useForm } from 'react-hook-form';
import { Input } from 'src/components/Input/Input';
import { saveDepartmentName } from 'src/components/EnterpriseDepartmentDetails/EnterpriseDepartmentName/EnterpriseDepartmentHooks/departmentHooks';

interface IDepartmentEdit {
  corpId: string;
  departmentId: string;
  departmentName: string;
  submitSuccess: (newDepartmentName: string) => void;
  onCancel: () => void;
}

interface INewDepartmentName {
  newDepartmentName: string;
}

export default function DepartmentNameEditMode({
  corpId,
  departmentId,
  submitSuccess,
  onCancel,
  departmentName,
}: IDepartmentEdit): JSX.Element {
  const { register, handleSubmit, formState } = useForm<INewDepartmentName>({
    defaultValues: {
      newDepartmentName: departmentName || null,
    },
    mode: 'onChange',
  });

  const { isDirty, isValid, errors, isSubmitting } = formState;

  async function onNameSubmit({ newDepartmentName }) {
    const saveIsSuccessful = await saveDepartmentName(
      corpId,
      departmentId,
      newDepartmentName
    );
    if (saveIsSuccessful) {
      submitSuccess(newDepartmentName);
    }
  }

  return (
    <>
      <Column desktop={6} gutter={12}>
        <Input
          name="newDepartmentName"
          id="newDepartmentName"
          data-testid="newDepartmentName-input"
          ref={register({
            required: 'Department name is required',
            maxLength: {
              value: 50,
              message: 'Should be less than 50 characters',
            },
          })}
          error={errors.newDepartmentName}
        />
      </Column>
      <Column desktop={4} gutter={12}>
        <Button
          type="submit"
          variant="primary"
          buttonSize="small"
          block
          disabled={!isDirty || !isValid}
          onClick={handleSubmit(onNameSubmit)}
          isLoading={isSubmitting}
          aria-busy={isSubmitting}
        >
          Save name
        </Button>
      </Column>
      <Column desktop={2} gutter={12}>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
      </Column>
    </>
  );
}
